import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Team',
    href: '/team'
  }, {
    name: 'Impact',
    href: '/impact'
  }, {
    name: 'Programs',
    href: '/programs'
  }, {
    name: 'Journey',
    href: '/journey'
  }, {
    name: 'Articles',
    href: '/articles'
  }, {
    name: 'Join',
    href: '/join'
  }];
  return <>
      <header className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none" data-id="element-277" data-mp="mg4bjqa31zv8">
        <div className={`pointer-events-auto flex items-center justify-between w-full max-w-6xl px-4 py-3 rounded-full transition-all duration-300 ${isScrolled ? 'bg-midnight/90 backdrop-blur-md text-ivory shadow-xl border border-white/10' : 'bg-midnight/80 backdrop-blur-sm text-ivory border border-transparent'}`} data-id="element-278" data-mp="rfqn7va9j81x">
          <Link to="/" className="flex items-center gap-3 group pl-2" data-id="element-279" data-mp="157nbtpcq2ztk">
            <img src="https://cdn.magicpatterns.com/uploads/sYKw6EQRHnT1SEh4hRD4M5/Camp_David_Logo.jpg" alt="Camp David Logo" className="h-8 w-auto object-contain rounded-full" loading="eager" data-id="element-280" data-mp="1a4n8j9nomq80" />
            <div className="flex flex-col" data-id="element-281" data-mp="ufqudq2qnqqm">
              <span className="font-display font-bold text-base leading-tight tracking-tight" data-id="element-282" data-mp="ugig896jaa3p">
                Camp David
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1 bg-white/5 rounded-full px-2 py-1" data-id="element-283" data-mp="147d6domwhtuf">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.name} to={link.href} className={`relative px-3 py-2 text-sm font-medium transition-colors rounded-full whitespace-nowrap hover:text-gold ${isActive ? 'text-gold' : 'text-ivory/80'}`} data-id="element-284" data-mp="1d8bb6955y5e2">
                  {link.name}
                  {isActive && <motion.div layoutId="nav-indicator" className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-gold" data-id="element-285" data-mp="3ox2k1ybvb9lj" />}
                </Link>;
          })}
          </nav>

          <div className="hidden md:flex items-center pr-1" data-id="element-286" data-mp="24cyp6c0wk94z">
            <Link to="/#donate" className="bg-gold text-midnight px-6 py-2.5 rounded-full text-sm font-bold tracking-wide hover:scale-105 hover:bg-white transition-all active:scale-95" data-id="element-287" data-mp="1pp3vasb5ryqb">
              Donate
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-current bg-white/10 rounded-full hover:bg-white/20 transition-colors" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-288" data-mp="1kqixezjdpr51">
            <Menu className="w-5 h-5" data-id="element-289" data-mp="1bq4bbxylc80h" />
          </button>
        </div>
      </header>

      {/* Mobile Nav Overlay */}
      <AnimatePresence data-id="element-290" data-mp="3152e3nw51z4q">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-[100] bg-midnight flex flex-col" data-id="element-291" data-mp="363lvrc3p8ora">
            <div className="flex items-center justify-between p-6" data-id="element-292" data-mp="n2s22hh7cj4q">
              <Link to="/" className="flex items-center gap-3" data-id="element-293" data-mp="n4368iek7swd">
                <img src="https://cdn.magicpatterns.com/uploads/sYKw6EQRHnT1SEh4hRD4M5/Camp_David_Logo.jpg" alt="Camp David Logo" className="h-10 w-auto object-contain rounded-full" data-id="element-294" data-mp="i9ywjrdwt6rl" />
                <span className="font-display font-bold text-xl text-ivory tracking-tight" data-id="element-295" data-mp="4bh8tto07u9o">
                  Camp David
                </span>
              </Link>
              <button className="p-3 bg-white/10 rounded-full text-ivory hover:bg-white/20 transition-colors" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu" data-id="element-296" data-mp="3vk4xojlgdzlz">
                <X className="w-6 h-6" data-id="element-297" data-mp="2kxnr2adog322" />
              </button>
            </div>

            <div className="flex-1 flex flex-col justify-center px-8 gap-6" data-id="element-298" data-mp="2ozsj54oh8rml">
              {navLinks.map((link, i) => <motion.div key={link.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} data-id="element-299" data-mp="1sab25tk1nj5l" data-mpi={i}>
                  <Link to={link.href} className={`text-5xl font-display font-bold tracking-tighter block ${location.pathname === link.href ? 'text-gold' : 'text-ivory'}`} data-id="element-300" data-mp="19jjwp336gcwh">
                    {link.name}
                  </Link>
                </motion.div>)}
            </div>

            <div className="p-8 pb-12" data-id="element-301" data-mp="2bw6ckc5sofh2">
              <Link to="/#donate" className="block w-full bg-gold text-midnight py-4 rounded-full text-center font-bold text-lg tracking-wide active:scale-95 transition-transform" data-id="element-302" data-mp="2ql2sswi08ysr">
                Donate
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}